export const esLang = {
  languageKey: 'es',
  translates: {},
};
